<template>
  <div>
    <b-form-group label="Thickness">
      <b-input-group>
        <b-input
          v-model="thickness"
          :max="100"
          :min="0"
          type="range"
          @input="changeShadow"
        />
        <template #append>
          <b-input
            v-model="thickness"
            :max="100"
            :min="0"
            type="number"
            @input="changeShadow"
          />
        </template>
      </b-input-group>
    </b-form-group>
    <b-form-group label="Blur">
      <b-input-group>
        <b-input
          v-model="blur"
          :max="100"
          :min="0"
          type="range"
          @input="changeShadow"
        />
        <template #append>
          <b-input
            v-model="blur"
            :max="100"
            :min="0"
            type="number"
            @input="changeShadow"
          />
        </template>
      </b-input-group>
    </b-form-group>
    <b-form-group label="Color">
      <ColorPicker
        v-model="color"
        opacity
        copy
        position="right-middle"
        @input="changeShadow"
      />
    </b-form-group>
  </div>
</template>

<script>
import ColorPicker from "@frontend/components/modules/layouts-page/EditorControl/components/ColorPicker.vue";
import { applyOutlineShadow } from "@/common/preview/draw-multi-line-text";

export default {
  name: "OutlineShadow",
  components: { ColorPicker },
  props: {
    target: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      thickness: 2,
      selectedShape: "round",
      alignment: "outside",
      color: "rgba(0,0,0,1)",
      blur: 0,
    };
  },
  watch: {
    target: {
      handler(val) {
        if (val?.outlineShadow?.outline) {
          this.thickness = Number(val.outlineShadow.outline.thickness) || 0;
          this.color = val.outlineShadow.outline.color || "rgba(0,0,0,1)";
          this.blur = Number(val.outlineShadow.shadow?.blur) || 0;
          this.selectedShape = val.outlineShadow.outline.selectedShape || "round";
          this.alignment = val.outlineShadow.outline.alignment || "outside";
        } else {
          this.changeShadow();
        }
      },
      immediate: true,
    },
  },
  methods: {
    changeShadow() {
      const canvas = this.target.canvas;
      const currentTarget = this.target;

      const color = this.color;
      const thickness = this.thickness;
      const blur = this.blur;
      const selectedShape = this.selectedShape || "round";
      const alignment = this.alignment || "outside";

      const outlineShadow = {
        outline: {
          thickness: +thickness,
          selectedShape,
          alignment,
          color,
        },
        shadow: {
          blur: +blur,
          color,
          offsetX: 0,
          offsetY: 0,
        },
      };

      applyOutlineShadow(currentTarget, outlineShadow);

      canvas.renderAll();
      canvas.fire("shadow:changed", currentTarget);
    },
  },
};
</script>
